import { apiClient, retryRequest } from './httpClient';

// Get auth token
export async function getAuthToken(endpoint, method = "POST", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'POST') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'Auth token request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = method;
        throw err;
    }
}